import { render } from "./Docs.vue?vue&type=template&id=153aed6d&bindings={\"renderToc\":\"data\"}"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render

export default script